import { FingerprintProvider as FpSdkProvider, useVisitorData } from '@fingerprint/react';
import * as Sentry from '@sentry/react';
import { ReactNode, useCallback } from 'react';

interface FingerprintProviderProps {
  children: ReactNode;
}

const isFingerprintEnabled = import.meta.env.VITE_FINGERPRINT_ENABLED === 'true';
const FINGERPRINT_KEY = import.meta.env.VITE_FINGERPRINT_KEY;
const FINGERPRINT_ENDPOINT = import.meta.env.VITE_FINGERPRINT_ENDPOINT;
const FINGERPRINT_REGION = 'eu';

const FingerprintProvider = ({ children }: FingerprintProviderProps) => (
  <FpSdkProvider
    apiKey={FINGERPRINT_KEY || 'disabled'}
    region={FINGERPRINT_REGION}
    endpoints={FINGERPRINT_ENDPOINT ? [FINGERPRINT_ENDPOINT] : undefined}
  >
    {children}
  </FpSdkProvider>
);

export function useFingerprint() {
  const { getData: getVisitorData } = useVisitorData({ immediate: false });

  const getData = useCallback(async () => {
    if (!isFingerprintEnabled) return null;
    try {
      return await getVisitorData();
    } catch (error) {
      Sentry.captureException(error);
      return null;
    }
  }, [getVisitorData]);

  return { getData };
}

export default FingerprintProvider;
